// tslint:disable-next-line: naming-convention
export const environment = {
  production: true,
  hmr: false,
};
